<template>
    <div class="homeBody">
        <div class="width_total_100 headerBgNew animateContent homeAnimate1" >
            <div class="w_container">
                <div class="commonTop">
                    <OmpLink></OmpLink>
                </div>
                <div class="bannerPart">
                    <div class="title-tw"></div>
                </div>
                 <!-- <el-carousel height="630px">
                    <el-carousel-item v-for="(img,i) in imgList" :key="i"> -->
                     <!-- <div class="bannerPart">
                         <a href="https://industry.digiwin.com/smarterp-40event" class="special" v-if="i==1||i==3" target="_blank">
                        <img :src="img.url" :width="i==1||i==3?'100%':'68%'" :height="i==1||i==3?'100%':'68%'" style="cursor: pointer;">
                        </a>
                         <img :src="img.url" :width="i==1||i==3?'100%':'68%'" :height="i==1||i==3?'100%':'68%'" 
                         v-else style="position:relative;left:50%;transform:translateX(-50%)">
                     </div> -->
                    <!-- </el-carousel-item>
                </el-carousel> -->
                <div class="picPlate" >
                     <FreeTryButtonTW @getFreeTryVisible="getVisible"></FreeTryButtonTW>
                   
                </div>
                <div class="instruction">
                    <div class="proInstruTitle">
                    </div>
                    <div class="circle"></div>
                    <div class="proInstruContent">
                        <ul>
                             <li>
                                <div class="instruConPer">
                                    <div class="pic-1"></div>
                                    <div class="left">
                                        <div class="left-top-1"></div>
                                        <div class="left-bottom-1"></div>
                                    </div>
                                </div>
                            </li>
                             <li>
                                <div class="instruConPer">
                                     <div class="pic-2"></div>
                                    <div class="left">
                                        <div class="left-top-2"></div>
                                        <div class="left-bottom-2"></div>
                                    </div>
                                </div>
                            </li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="video-content">
                <div class="video-title"></div>
                 <ExpericeIntroTW></ExpericeIntroTW>
            </div>
           
             <div class="understand">
                <div class="title"></div>
                <div class="bottom-banner-01" @click="goLinkManage">
                </div>
                <div class="bottom-banner-02" @click="goLinkSmart">
                </div>
                <Footer></Footer>
             </div>
        </div>
        <Control></Control>
        <FreeTry :visible.sync="freeTryVisible"></FreeTry>
    </div>
</template>
<script>
import "@/assets/css/tw-style.css"

import OmpLink from "@/components/common/OmpLink.vue"
import Control from "@/components/common/Control.vue"
import Footer from "@/components/common/Footer.vue"
import FreeTryButtonTW from "@/components/common/FreeTryButtonTW.vue"
import FreeTry from "@/components/common/FreeTry.vue"
import ExpericeIntroTW from '@/components/common/ExpericeIntroTW.vue'
  export default {
    components: {
        OmpLink,
        Control,
        Footer,
        FreeTryButtonTW,
        FreeTry,
        ExpericeIntroTW
    },
    name: 'newHome',
    data() {
      return {
        freeTryVisible: false,
        imgList:[
            {url:require("../assets/img/tw-img/title-tw.png")},
            {url:require("../assets/img/tw-img/GDN.jpg")},
            {url:require("../assets/img/tw-img/title-tw.png")},
             {url:require("../assets/img/tw-img/GDN.jpg")},
        ]
      }
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Home',
            contentName : ''
        }, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error)
        });
    },
    mounted () {
        this.homeTopAnimate() // 顶部动画
    },
    methods: {
        homeTopAnimate() {
            var homeAnimate_show1=1;
            $(".homeBody").children(".animateContent").each(function() {
                if($(this).hasClass("homeAnimate1") &&  parseInt(homeAnimate_show1)){
                    homeAnimate_show1 = 0;
                    $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                    $(this).find(".proInstruContent li").delay(800).addClass('flipInX animated hinge3');
                }
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        },
        toDwCloudMarket() {//跳转云市场次数埋点
            this.$http.post('/backend/web/record', {
                pageName: 'dwCloudMarket',
                contentName : ''
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        goLinkManage(){
            window.open("https://www.digiwin.com/tw/dsc/solution/WB002839/WB00283901.html?utm_source=digiwin&utm_medium=email&utm_campaign=中小_TBB體驗&utm_term=joyce&utm_content=方案")
        },
        goLinkSmart (){
             window.open("https://www.digiwin.com/tw/dsc/project/ServiceCloud/ServiceCloud.html#steward2?utm_source=digiwin&utm_medium=email&utm_campaign=中小_TBB體驗&utm_term=joyce&utm_content=方案")
        }
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/newHome.vue